import { Directive, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../auth/auth.service';
import { UserDto } from '../../auth/user.dto';
import { TPermission, TPermissionContext } from './permissions';
import { PermissionService } from './services/permission.service';

@Directive({
  selector: '[hasPermission]',
})
export class HasPermissionDirective implements OnInit, OnDestroy, OnChanges {
  @Input('hasPermission') set hasPermission(value: TPermission | TPermission[]) {
    this.permissions = Array.isArray(value) ? value : [value];
  }
  @Input('hasPermissionSubject') subject: any;
  @Input('hasPermissionContext') context: TPermissionContext;

  private readonly destroy$: Subject<void> = new Subject();
  private permissions: TPermission[] = [];
  private currentUser: UserDto;
  private isHidden: boolean = true;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private readonly authService: AuthService,
    private readonly permissionService: PermissionService,
  ) {}

  public async ngOnInit(): Promise<void> {
    this.currentUser = await this.authService.getUser();
    this.renderView();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasPermission || changes.hasPermissionSubject || changes.hasPermissionContext) {
      this.renderView();
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public renderView(): void {
    if (this.checkPermissions()) {
      if (this.isHidden) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.isHidden = false;
      }
    } else {
      this.isHidden = true;
      this.viewContainer.clear();
    }
  }

  public checkPermissions(): boolean {
    const userPermissions: TPermission[] = this.permissionService.getPermissions(this.currentUser, this.subject, this.context);
    return userPermissions?.length ? userPermissions.some((value: TPermission) => this.permissions?.includes(value)) : false;
  }
}
